function Footer(){
  return (
    <div className="footer">
      <p className="textright">Last updated 26/7/2024</p>
    </div>)
}

export default Footer
;
